module.exports = __webpack_public_path__ + "img/header-mobile.2450b442.jpg";